import request from '@/utils/request';

// 定义帖子类型
export interface PostItem {
  id: number;
  userId: number;
  title: string;
  content: string;
  coverImage: string;
  status: number;
  riskLevel: number;
  aiChecked: number;
  viewCount: number;
  likeCount: number;
  favoriteCount: number;
  commentCount: number;
  createTime: string;
  updateTime: string;
}

// 定义API响应类型
export interface DashboardResponse {
  code: number;
  msg: string | null;
  data: PostItem[];
}

// 获取首页数据
export function getUserDashboardData(): Promise<DashboardResponse> {
  return request({
    url: '/user/dashboard',
    method: 'get'
  });
}